// Returning-user selector nav gating (Profile-nav bug fix — option B).
//
// The home selector may surface restrained "PROFILE · KEEPERS" utility links
// for a returning visitor. These two links have INDEPENDENT evidence states:
//
//  * PROFILE is reachable only when a FINALIZED (completed) Taste Profile
//    exists for the session — GET /sessions/{id}/profile returns 404 otherwise.
//    Keepers evidence alone (which accumulates from ANY kept comparison, even
//    an unfinished run) must NOT surface a Profile link, because clicking it
//    would 404 and bounce the user back to the home screen. So the Profile link
//    is gated strictly on the presence of that finalized profile.
//
//  * KEEPERS is shown per its own valid evidence state (>=1 kept work),
//    completely independent of whether a finalized Profile exists yet.

export function canShowProfileNav(returningProfile) {
  return !!returningProfile;
}

export function canShowKeepersNav(keepers) {
  return !!(keepers && keepers.total > 0);
}
